const verifiedUserIDs: string[] = [
  "3y8XlQiLCscOR3uQ7UwrSCHgF932",
  "GJTtKYbJG8M2ag3rJdVSpHCGWMz2",
  "5n86oOReOGQX4M8b1Lb3jivjKRT2",
  "S8FGjp8ZmmRTnGbW87aN3S3RaVT2",
];

export default verifiedUserIDs;
